import { createIcon } from '@chakra-ui/icons';

export const AngleLeft = createIcon({
  displayName: 'AngleLeft',
  viewBox: '0 0 4 6',
  path: [
    <svg width="4" height="6" viewBox="0 0 4 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 0.5L0.5 3L3 5.5"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
